if (!customElements.get('newsletter-modal')) {
  customElements.define('newsletter-modal', class NewsletterModal extends HTMLElement {
    constructor() {
      super();
      this.key = this.dataset.storageKey;
      this.canSetKey = false;
      this._initialized = false;
      this._openRetries = 0;
    }

    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this.init();
    }

    init() {
      if (this.dataset.testMode === 'true') {
        this.openModalWithDelay(0);
        return;
      }

      this.form = this.querySelector('form');
      if (
        this.form &&
        window.location.href.includes(`customer_posted=true#${this.form.id}`) &&
        !sessionStorage.getItem(this.key + '_submitted')
      ) {
        sessionStorage.setItem(this.key + '_submitted', true);
        this.openModalWithDelay(0);
        return;
      }

      if (this.dataset.frequency === 'once' && sessionStorage.getItem(this.key)) {
        return;
      }

      if (this.dataset.frequency === 'once') {
        this.canSetKey = 'session';
        this.openModalIfAllowed();
        return;
      }

      if (!localStorage.getItem(this.key)) {
        this.canSetKey = 'local';
        this.openModalIfAllowed();
        return;
      }

      const frequency = parseInt(this.dataset.frequency.split('_')[0], 10);
      const timeNow = this.generateTimeStamp();
      const timeThen = parseInt(localStorage.getItem(this.key), 10);
      const timeDiffInDays = (timeNow - timeThen) / (1000 * 3600 * 24);

      if (timeDiffInDays >= frequency) {
        this.canSetKey = 'local';
        this.openModalIfAllowed();
      }
    }

    openModalIfAllowed() {
      if (!window.Shopify?.customerPrivacy) {
        this.openModalWithDelay();
        return;
      }

      if (
        window.Shopify.customerPrivacy.userCanBeTracked?.() ||
        window.Shopify.customerPrivacy.userDataCanBeSold?.()
      ) {
        this.openModalWithDelay();
        return;
      }

      const privacyFallback = window.setTimeout(() => {
        this.openModalWithDelay();
      }, 8000);

      document.addEventListener(
        'trackingConsentAccepted',
        () => {
          window.clearTimeout(privacyFallback);
          this.openModalWithDelay();
        },
        { once: true }
      );
    }

    openModalWithDelay(delay) {
      const wait = delay != null ? delay : Number(this.dataset.delay || 0);
      window.setTimeout(() => {
        this.openModal();
      }, wait);
    }

    isAnotherDialogOpen() {
      return Boolean(
        document.querySelector('.modal.is-open, .drawer.is-open, #fy-cart-added-modal.is-open')
      );
    }

    showPromoModal() {
      if (window.Woolman?.ModalsAndDrawers?.showModalOrDrawer) {
        window.Woolman.ModalsAndDrawers.showModalOrDrawer(this.id);
        return;
      }

      this.classList.add('initialized', 'is-open');
      document.body.classList.add('overflow-hidden');
    }

    openModal() {
      if (this.isAnotherDialogOpen()) {
        this._openRetries += 1;
        if (this._openRetries < 20) {
          this.openModalWithDelay(3000);
        }
        return;
      }

      if (this.canSetKey === 'session') {
        sessionStorage.setItem(this.key, this.generateTimeStamp());
      } else if (this.canSetKey === 'local') {
        localStorage.setItem(this.key, this.generateTimeStamp());
      }

      this.showPromoModal();
    }

    generateTimeStamp() {
      return new Date().getTime();
    }
  });
}
